import { render } from "./UserFormModal.vue?vue&type=template&id=5bd240df&scoped=true"
import script from "./UserFormModal.vue?vue&type=script&lang=js"
export * from "./UserFormModal.vue?vue&type=script&lang=js"

import "./UserFormModal.vue?vue&type=style&index=0&id=5bd240df&scoped=true&lang=css"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5bd240df"]])

export default __exports__